export const STORAGE_FULL_MESSAGE='Storage is full right now. Your progress is kept on this device.';
